import React, { useContext, useState } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import { PERMISSIONS } from '@Const/permissions'
import RightsholderContactFormView from '@Components/RightsholderContact/RightsholderContactFormView'
import { useNavigate } from 'react-router'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { observer } from 'mobx-react'

interface RightsholderContactInformationViewProps {
    setIsEditableState: (isEdit: any) => void
}

const RightsholderContactInformationView = (props: RightsholderContactInformationViewProps) => {
    const { preloaderStore, popupStore, contactStore, userStore, rightsholderStore } = useContext(StoresContext)
    const navigate = useNavigate()
    const [isPopupOpen, setIsPopupOpen] = useState(false)

    const rightsholderContact = contactStore.rightsholderContact

    if (!rightsholderContact) {
        navigate(Navigation.rightholder.maintenance.memberContacts(rightsholderStore.currentRightsholderId))
        return <></>
    }

    const deleteRightsholderContact = () => {
        preloaderStore.openTransparentPreloader(true)
        contactStore
            .deleteRightsholderContact(rightsholderContact.ipId, rightsholderContact.id)
            .then(() => {
                navigate(Navigation.rightholder.maintenance.memberContacts(rightsholderContact.ipId))
                popupStore.setAlertData('Your Contact was successfully deleted.', false)
            })
            .catch((error) => popupStore.setAlertData(error.message, true))
            .finally(() => preloaderStore.openTransparentPreloader(false))
    }

    const handleCancel = () => {
        setIsPopupOpen(false)
    }

    return (
        <>
            <div className="view-contact-block">
                <div className="body-title">
                    <h3>View Contact</h3>
                </div>
                <div className="view-contact-border-block">
                    <RightsholderContactFormView rightsholderContact={rightsholderContact} />
                    <PermissionCheck
                        requiredPermissions={[PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address]}
                        orIsInternal
                    >
                        <div className="buttons-block">
                            <Button mainColor={false} type="primary" onClick={() => setIsPopupOpen(true)}>
                                Remove
                            </Button>
                            <Button
                                mainColor
                                type="primary"
                                className="blue-border"
                                onClick={() =>
                                    props.setIsEditableState({
                                        reload: false,
                                        isEditable: true,
                                    })
                                }
                            >
                                Edit
                            </Button>
                        </div>
                    </PermissionCheck>
                </div>
            </div>
            <ModalPortal isOpen={isPopupOpen} onClose={handleCancel}>
                <Popup onClose={handleCancel}>
                    <div className="delete-contact-action">
                        <ConfirmationPopup
                            title="Are you sure you want to remove?"
                            onCancel={handleCancel}
                            onConfirm={deleteRightsholderContact}
                            cancelButtonText="Cancel"
                            confirmButtonText="Yes, I want to remove"
                            confirmButtonClassName="confirm-delete-contact-button"
                            disabled={userStore.isInternal}
                        >
                            <p className="sub-text">Clicking remove will delete this contact.</p>
                        </ConfirmationPopup>
                    </div>
                </Popup>
            </ModalPortal>
        </>
    )
}

export default observer(RightsholderContactInformationView)
